import React from 'react';
import Button from '@mui/material/Button';

export default function CompetitionCoursesSection({
  selectedCourses,
  onOpenPicker,
}) {
  return (
    <div className="mt-6 rounded-[24px] border border-white/10 bg-white/5 p-4">
      <div className="flex flex-col gap-3 border-b border-white/10 pb-4 md:flex-row md:items-center md:justify-between">
        <div className="text-left">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-cyan-300">Pelattavat radat</p>
          <p className="mt-2 text-sm leading-6 text-slate-300">
            Avaa valintamodaali, josta voit hakea ratoja nimen, paikkakunnan tai maakunnan mukaan ja lisätä uuden radan, jos sitä ei löydy.
          </p>
        </div>
        <Button type="button" variant="contained" color="primary" onClick={onOpenPicker}>Valitse radat</Button>
      </div>

      <div className="mt-4 flex flex-wrap gap-3">
        {selectedCourses.length ? selectedCourses.map((course) => (
          <div key={course.courseID} className="rounded-2xl border border-cyan-300/40 bg-cyan-400/10 px-4 py-3 text-sm text-white">
            <p className="font-semibold">{course.name}</p>
            <p className="mt-1 text-xs text-slate-300">{course.municipality}, {course.region}</p>
          </div>
        )) : (
          <div className="rounded-2xl border border-dashed border-white/10 bg-slate-950/20 px-4 py-6 text-center text-sm text-slate-400">
            Ratoja ei ole vielä valittu.
          </div>
        )}
      </div>
    </div>
  );
}